import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  MelcoModelsUser,
  useFormSubmit,
} from "melco-shared-logic";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { useQueryClient } from "react-query";
import { useAddUserProfile } from "../../../hooks/users/useAddUserProfile";
import { DisplayAddUserForm } from "../form/DisplayAddUserForm";
import * as Yup from "yup";
import { EmailAvailabilityState } from "../../common/EmailFieldWithAvailabilityCheck";

type UserDetailProfileDrawerProps = {
  isAddProfileDrawerOpen: boolean;
  closeAllDrawerAction: () => void;
};

export type addUserFormType = {
  first_name?: string | null;
  last_name?: string | null;
  address?: {
    country_code?: string | null;
  };
  password?: string | null;
  confirm_password?: string;
  user_name?: string | null;
  email?: string | null;
};

export const UserAddProfileDrawer: React.FC<UserDetailProfileDrawerProps> = ({
  closeAllDrawerAction,
  isAddProfileDrawerOpen,
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const queryKey = "addprofle";
  const addUserProfile = useAddUserProfile();

  const initialValues: addUserFormType = {
    first_name: "",
    last_name: "",

    address: {
      country_code: "",
    },
    confirm_password: "",
    password: "",
    user_name: "",
    email: "",
  };

  const generateUserProfileToInitialValues = (formvalues: addUserFormType) => {
    const {
      first_name,
      last_name,
      address,
      user_name,
      email,
      confirm_password,
      password,
    } = formvalues;

    const initialValues: addUserFormType = {
      first_name: first_name ?? "",
      last_name: last_name ?? "",

      address: {
        country_code: address?.country_code ?? "",
      },
      confirm_password: confirm_password,
      password: password ?? "",
      user_name: user_name ?? "",
      email: email ?? "",
    };

    return initialValues;
  };

  const onSubmit = async (
    values: MelcoModelsUser,
    formikHelpers: FormikHelpers<MelcoModelsUser>
  ) => {
    await onAddUserProfile(values, formikHelpers, {});
  };

  const formSubmitToAddUserProfile = () => {
    return [
      async (
        values: MelcoModelsUser,
        formikHelpers: FormikHelpers<MelcoModelsUser>
      ) => {
        return handleAddProfile(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: ["users.actions", "add"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const handleAddProfile = async (
    values: MelcoModelsUser,
    formikHelpers: FormikHelpers<MelcoModelsUser>,
    options: {}
  ) => {
    values["address"] = { ...values.address, type: "P" };
    values["user_name"] = values.email ?? "";

    console.log(values);
    const newEntity = await addUserProfile(values);

    formikHelpers.resetForm({
      values: generateUserProfileToInitialValues(
        newEntity
          ? {
            email: newEntity?.email ?? "",
            password: newEntity?.password ?? "",
            confirm_password: "",
            address: {
              country_code: newEntity?.address?.country_code ?? "",
            },
            first_name: newEntity?.first_name ?? "",
            last_name: newEntity?.last_name ?? "",
            user_name: newEntity?.user_name ?? "",
          }
          : {
            email: "",
            password: "",
            confirm_password: "",
            address: {
              country_code: "",
            },
            first_name: "",
            last_name: "",
            user_name: "",
          }
      ),
    });
    queryClient.setQueryData(queryKey, newEntity);

    //  setAddProfileDrawerAction(true);
    closeAllDrawerAction();
  };

  const onAddUserProfile = useFormSubmit(...formSubmitToAddUserProfile());

  const AddUserProfileFormSchema = Yup.object().shape({
    email: Yup.string()
      // .email("global.error.shouldbe.email")
      // .required("global.error.required.default")
      .test(
        "isNotTaken",
        "global.error.user_name_exists",
        (_, context) =>
          context.parent.isEmailAvailable !== EmailAvailabilityState.Taken
      ),
    //  first_name: Yup.string().required("global.error.required.default"),
    // last_name: Yup.string().required("global.error.required.default"),
    // address: Yup.object().shape({ country_code: Yup.string().required("global.error.required.default")}),
    //  password: Yup.string().required("global.error.required.default"),
    confirm_password: Yup.string()
      .required("global.error.required.default")
      .oneOf([Yup.ref("password")], "global.error.match.password"),
  });

  return (
    <Drawer
      title={t("users.actions.add.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeAllDrawerAction}
      open={isAddProfileDrawerOpen}
      bodyStyle={{ padding: 10 }}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={AddUserProfileFormSchema}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayAddUserForm />
        </DirtyFormPrompt>
      </Formik>
    </Drawer>
  );
};
